import { PaymentAPI } from '@/api/payment'
import { CancellationToken } from '@/utils/cancel'

export default function checkTransactionStatus(
  walletTransactionId: string,
  cancellationToken: CancellationToken
) {
  return new Promise<boolean>((resolve, reject) => {
    const POLL_INTERVAL = 3000
    const MAX_LOOP = 60 / (POLL_INTERVAL / 1000)

    let timer: NodeJS.Timer
    let loop = 0

    const checkTransactionStatus = async () => {
      loop++
      console.log('[PAYMENT] Checking TX status')
      try {
        const res = await PaymentAPI.getTransactionStatus(walletTransactionId)

        if (res.data.payload!.status === 'Success') {
          clearInterval(timer)
          console.log('[PAYMENT] TX status is success.')
          resolve(true)
          return
        } else if (res.data.payload!.status === 'Failure') {
          resolve(false)
          return
        }
      } catch (err) {
        console.error('[PAYMENT] Unable to get transaction status. Continuing')
      } finally {
        if (cancellationToken.cancelled) {
          clearInterval(timer)
          console.log('[PAYMENT] Check TX status cancelled.')
          reject(new Error('Cancelled'))
        } else if (loop >= MAX_LOOP) {
          console.log('[PAYMENT] Check TX status timed out.')
          reject(new Error('Timed out'))
        }
      }
    }

    timer = setInterval(checkTransactionStatus, 3000)
    checkTransactionStatus().then()
  })
}
